
import React, { Component } from 'react';
import './add-new-coordinator.scss'
import { Modal, ModalBody } from "reactstrap";
import SchoolApi from '../../../apis/school'
import Dropdown from '../../common/dropdown-v2/dropdown';
import CommonApi from '../../../apis/common'
import { ImageConstants, Constants } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'
import CommonUtils from '../../../utility/common-utilities';

class AddCoordinator extends Component {
    constructor(props) {
        super(props)

        if (this.props.mode === 'EDIT') {

            this.state.selectedUser = this.props.selectedUser;
            this.state.firstName = this.props.selectedUser.firstName;
            this.state.gender = this.props.selectedUser.gender;
            this.state.lastName = this.props.selectedUser.lastName;
            this.state.email = this.props.selectedUser.email;
            this.state.selectedCountryCode = this.props.selectedUser.countryCode;
            this.state.mobileNumber = this.props.selectedUser.mobileNumber;
            this.state.landline = this.props.selectedUser.landline;
            this.state.selectedTypes = this.props.selectedUser?.types?.map(type => type?.type) || []
            this.state.types = this.props.selectedUser?.types
        }
        this.state.staffType = this.props.type

    }

    state = {

        types: [{type: "COORDINATOR"}],
        selectedCountryCode: '+91',
        countryCodeDropdown: [],
        staffTypesDropdown: []
    }

    genderDropdown = Constants.SCHOOL_ONBOARD.GENDER_LIST

    componentDidMount() {
        this.getStaffTypesDetails()
        this.getCountryCodes();
    }

    getStaffTypesDetails(payload = {}) {

        SchoolApi.getStaffTypes(payload)
            .then(staffTypes => {
                const types = this.state.types
                let items = [];
                for (let i = 0; i < staffTypes.response.length; i++) {
                    items.push({
                        title: staffTypes.response[i].displayType,
                        value: staffTypes.response[i].type,
                    })
                }

                this.setState({ staffTypesDropdown: items })
            }).catch(err => {
            })
    }

    getCountryCodes(payload = {}) {

        CommonApi.getCountryCodeList(payload).then(response => {
            let data = response.response
            if (data.length) {
                this.setState({ countryList: data })
                let countryCodeDropdown = this.buildCountryCodeDropdown(data)
                this.setState({ countryCodeDropdown: countryCodeDropdown })

            }
        }).catch(err => {
        })

    }


    onSelectType = (option) => {
        let types = option.map(item => ({ type: item.value }))
        this.setState({ types })
    }

    onCountryCodeSearch(value, index) {
        if (value.length > 2 || !value) {
            this.countryCodeIndex = index
            this.getCountryCodes({ name: `/${value}`, })
        }
    }

    onSelectCountryCode(option) {
        this.setState({ selectedCountryCode: option?.value })
    }


    buildCountryCodeDropdown(list = []) {
        let countryCodeDropdown = [];
        let countryCodeHash = {}
        for (let i = 0; i < list.length; i++) {
            let item = list[i]

            if (!countryCodeHash[item.dialCode]) {
                countryCodeHash[item.dialCode] = item.dialCode
                countryCodeDropdown.push({ title: `${item.name} ${item.dialCode}`, value: item.dialCode })
            }
        }
        return countryCodeDropdown
    }


    onSelectType = (option) => {
        let types = option.map(item => ({ type: item.value }))
        this.setState({ types })
    }

    onSelectGender = (option) => {
        this.setState({ gender: option?.value })
    }

    onChangeHandler = (event, key) => {
        if (key == "mobileNumber" && !this.state.mobileNumber) {
            if (!CommonUtils.isAllowMobileNumber(event.target.value)) {
                let stateValue = this.state.mobileNumber
                this.setState({ mobileNumber: "" }, () => {
                    this.setState({ mobileNumber: stateValue })
                })
                return
            }
        }
        this.setState({ [key]: event.target.value })
    }

    onSave() {
        if (this.state.isSubmit) return
        let payload = {
            types: this.state.types,
            gender: this.state.gender,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email ? this.state.email.trim() : "",
            countryCode: this.state.selectedCountryCode,
            mobileNumber: this.state.mobileNumber,
            landline: this.state.landline
        }

        if (!this.validatePayload(payload)) return
        this.setState({ isSubmit: true })

        if (this.props.mode === 'EDIT') {
            payload._id = this.props.selectedUser?._id
            SchoolApi.updateStaff(payload).then(response => {
                this.props.onSave()
                this.setState({ isSubmit: false })
            }).catch(err => {
                if (err.response && err.response.data && err.response.data.code == 11000) {
                    this.setState({ errorMessage: 'Email Id already exists', isInvalidEmail: true })
                }
                this.setState({ isSubmit: false })
            })
        } else {
            SchoolApi.createStaff(payload).then(response => {
                this.props.onSave()
                this.setState({ isSubmit: false })
            }).catch(err => {
                if (err.response && err.response.data && err.response.data.code == 11000) {
                    this.setState({ errorMessage: 'Email Id already exists', isInvalidEmail: true })
                }
                this.setState({ isSubmit: false })
            })
        }

    }


    validatePayload(payload = {}) {

        if (!payload.types || !payload.types?.length) {
            this.setState({ errorMessage: "Please select type" })
            return false
        }

        if (!payload.gender) {
            this.setState({ errorMessage: "Please select gender" })
            return false
        }

        if (!payload.firstName) {
            this.setState({ errorMessage: "Please enter first name" })
            return false
        }
        if (!payload.lastName) {
            this.setState({ errorMessage: "Please enter last name" })
            return false
        }

        if (!this.validateEmail(payload.email) || !payload.email) {
            this.setState({ errorMessage: "Invalid email" })
            return false
        }
        if (!payload.countryCode && payload.mobileNumber) {
            this.setState({ errorMessage: "Please enter mobile number" })
            return false
        }
        this.setState({ errorMessage: "" })
        return true
    }

    validateEmail(value) {
        if (value) {
            let isValid = CommonUtils.validateEmail(value);
            if (!isValid) {
                this.setState({ isInvalidEmail: true });
                return false
            }
            else {
                this.setState({ isInvalidEmail: false })
                return true
            }
        } else {
            this.setState({ isInvalidEmail: true });
            return false
        }
    }

    render() {
        const {staffType} = this.state
        return (
            <Modal className="cw-custom-modal" isOpen={this.props.show} toggle={this.props.onClose} size={this.props.size || 'md'}>

                <ModalBody >

                    <div className="row">
                        <div className="col">
                            <img className="close-icon cursor-pointer" onClick={this.props.onClose} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>

                    <div className="add-admin-new-contact">

                        <div className="header-text text-center">
                            <span>{this.props.mode === "EDIT" ? "EDIT" :"ADD NEW"} COORDINATOR</span>
                        </div>
                        {this.props.mode === "EDIT" &&
                            <div className='row bw-spaces-input'>
                                <div className='col'>
                                    <label className='cw-input-label'>TYPE <span className='star'>*</span></label>
                                    {
                                    this.state.staffTypesDropdown?.length ?
                                            <Dropdown
                                                multiSelect
                                                placeholder='Select Type'
                                                options={this.state.staffTypesDropdown}
                                                onSelect={(option) => this.onSelectType(option)}
                                                text={"title"}
                                                style={{ background: "#F6F7F5" }}
                                                value={this.state.selectedTypes || []}
                                                invalid={this.state.isSubmit && !this.state?.selectedTypes?.length}
                                            /> : ""}
                                </div>
                            </div>
                        }
                        <div className='bw-spaces-input'>
                            <div className='cw-input-label'>NAME <span className='star'>*</span></div>
                            <div className='row '>
                                <div className='col-2'>
                                    <Dropdown
                                        key="gender"
                                        placeholder='Mr.'
                                        options={this.genderDropdown}
                                        onSelect={(option) => this.onSelectGender(option)}
                                        text="title"
                                        style={{ background: "#F6F7F5" }}
                                        value={this.state.gender}
                                        invalid={this.state.isSubmit && !this.state.gender}
                                    />
                                </div>
                                <div className='col'>
                                    <input className={`cw-input ${this.state.isSubmit && !this.state.firstName ? "invalid" : ""}`} placeholder='Enter First Name'
                                        value={this.state.firstName}
                                        onChange={(e) => this.onChangeHandler(e, 'firstName')} />
                                </div>
                                <div className='col'>
                                    <input className={`cw-input ${this.state.isSubmit && !this.state.lastName ? "invalid" : ""}`} placeholder='Enter Last Name'
                                        value={this.state.lastName}
                                        onChange={(e) => this.onChangeHandler(e, 'lastName')} />
                                </div>
                            </div>
                        </div>


                        <div className='row bw-spaces-input'>
                            <div className='col'>
                                <label className='cw-input-label'>EMAIL ID <span className='star'>*</span></label>
                                <input className={`cw-input ${(this.state.isSubmit) || this.state.isInvalidEmail ? "invalid" : ""}`} placeholder='Enter Email Id'
                                    value={this.state.email}
                                    onChange={(e) => this.onChangeHandler(e, 'email')} />
                            </div>
                        </div>

                        <div className='row bw-spaces-input'>
                            <div className='col-7'>
                                <div>
                                    <label className='cw-input-label no-padding'>MOBILE NUMBER</label>
                                </div>
                                {
                                    this.state.countryCodeDropdown?.length ?
                                        <div className="col-4 pl-0 d-inline-block">
                                            <Dropdown
                                                key="countryCode"
                                                placeholder='Search country code'
                                                options={this.state.countryCodeDropdown}
                                                onSelect={(option) => this.onSelectCountryCode(option)}
                                                text="title"
                                                onSearch={(value) => this.onCountryCodeSearch(value)}
                                                style={{ background: "#F6F7F5" }}
                                                value={this.state.selectedCountryCode}
                                            />
                                        </div> : ""
                                }
                                <div className="col-8 d-inline-block">
                                    <div className="text-right optional-text">OPTIONAL</div>
                                    <input className={`cw-input ${this.state.isSubmit && (!this.state.selectedCountryCode && this.state.mobileNumber) ? "invalid" : ""}`} placeholder='Enter Mobile Number'
                                        value={this.state.mobileNumber}
                                        onChange={(e) => this.onChangeHandler(e, 'mobileNumber')} />
                                </div>
                            </div>
                            <div className='col-5'>
                                <label className='cw-input-label no-padding'>LANDLINE</label>
                                <div className="text-right "><span className='optional-text'>OPTIONAL</span></div>
                                <input className={`cw-input`} placeholder='Enter Landline'
                                    value={this.state.landline}
                                    onChange={(e) => this.onChangeHandler(e, 'landline')} />
                            </div>
                        </div>

                        <div className="text-center pt-4">
                            {this.state.errorMessage ? <div className="text-danger pb-4"><strong>{this.state.errorMessage} </strong></div> : ""}
                            <button className="cw-button-primary" onClick={() => this.onSave()}>
                                Save
                            </button>
                        </div>
                    </div>
                </ModalBody>

            </Modal >
        );
    }
}

export default AddCoordinator;